// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/etapaProducaoService.ts
//  Cadastro de Etapas de Produção (roteiro).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/etapas-producao';

export interface EtapaProducao {
  id: number;
  descricao?: string;
  referencia?: string;
  sequencia: number;
  isInativo: boolean;
  observacao?: string;
}

export interface SalvarEtapaProducaoRequest {
  descricao?: string;
  referencia?: string;
  sequencia?: number;
  isInativo?: boolean;
  observacao?: string;
}

export const etapaProducaoService = {
  async getAll(incluirInativas = false): Promise<EtapaProducao[]> {
    const { data } = await apiClient.get<EtapaProducao[]>(BASE, { params: { incluirInativas } });
    return data;
  },

  async create(request: SalvarEtapaProducaoRequest): Promise<EtapaProducao> {
    const { data } = await apiClient.post<EtapaProducao>(BASE, request);
    return data;
  },

  async update(id: number, request: SalvarEtapaProducaoRequest): Promise<EtapaProducao> {
    const { data } = await apiClient.put<EtapaProducao>(`${BASE}/${id}`, request);
    return data;
  },

  async remove(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
